import { TFunction } from 'i18next';
import { AriaSort, NextSortOrderKey } from './consts';

export const getAriaSort = (isActiveSort: boolean, isAsc: boolean) => {
  if (!isActiveSort) {
    return AriaSort.NONE;
  }
  return isAsc ? AriaSort.ASCENDING : AriaSort.DESCENDING;
};

export const getAriaLabel = (
  isActiveSort: boolean,
  isAsc: boolean,
  columnName: string,
  tt: TFunction
): string => {
  const nextSortOrder = isActiveSort && isAsc
    ? NextSortOrderKey.SORT_DESCENDING
    : NextSortOrderKey.SORT_ASCENDING;

  return tt(nextSortOrder, { column: columnName });
};

export const getDecorationIconWcagProps = () => ({
  'aria-hidden': true,
  'focusable': false,
});
